import React, { useState } from 'react';
import useAuth from '../../hooks/useAuth';

export default function SettingsContent() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { changePassword } = useAuth();

  const handlePasswordChange = async () => {
    if (newPassword !== confirmPassword) {
      alert('Yeni şifreler uyuşmuyor!');
      return;
    }
    
    if (newPassword.length < 6) {
      alert('Yeni şifre en az 6 karakter olmalıdır!');
      return;
    }
    
    setLoading(true);
    const result = await changePassword(currentPassword, newPassword);
    
    if (result.success) {
      alert(result.message);
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } else {
      alert(result.message);
    }
    setLoading(false);
  };

  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-8">Ayarlar</h1>
      
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-xl font-semibold mb-4">Şifre Değiştir</h2>
        
        <div className="max-w-md space-y-4">
          <PasswordField
            label="Mevcut Şifre"
            value={currentPassword}
            onChange={setCurrentPassword}
          />
          
          <div>
            <PasswordField
              label="Yeni Şifre"
              value={newPassword}
              onChange={setNewPassword}
            />
            {newPassword.length > 0 && newPassword.length < 6 && (
              <p className="text-red-500 text-sm mt-1">
                ⚠️ Şifre en az 6 karakter olmalıdır ({newPassword.length}/6)
              </p>
            )}
            {newPassword.length >= 6 && (
              <p className="text-green-500 text-sm mt-1">
                ✓ Şifre uzunluğu yeterli
              </p>
            )}
          </div>
          
          <div>
            <PasswordField
              label="Yeni Şifre (Tekrar)"
              value={confirmPassword}
              onChange={setConfirmPassword}
            />
            {confirmPassword.length > 0 && (
              <p className={`text-sm mt-1 ${
                newPassword === confirmPassword ? 'text-green-500' : 'text-red-500'
              }`}>
                {newPassword === confirmPassword ? '✓ Şifreler eşleşiyor' : '⚠️ Şifreler eşleşmiyor'}
              </p>
            )}
          </div>
          
          <div className="pt-2">
            <button
              onClick={handlePasswordChange}
              disabled={loading || newPassword.length < 6 || newPassword !== confirmPassword}
              className={`px-6 py-2 text-white rounded transition-colors ${
                loading || newPassword.length < 6 || newPassword !== confirmPassword
                  ? 'bg-gray-400 cursor-not-allowed' 
                  : 'bg-blue-600 hover:bg-blue-700'
              }`}
            >
              {loading ? 'Değiştiriliyor...' : 'Şifreyi Değiştir'}
            </button>
            
            <div className="mt-4 text-sm text-gray-600 space-y-1">
              <p className="font-medium">Şifre gereksinimleri:</p>
              <ul className="list-disc list-inside ml-2">
                <li>En az 6 karakter uzunluğunda olmalı</li>
                <li>Güvenliğiniz için karmaşık bir şifre seçin</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Password Field Component
function PasswordField({ label, value, onChange }) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <div className="relative">
        <input
          type={showPassword ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full px-3 py-2 border rounded focus:outline-none focus:border-blue-500 pr-10"
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
        >
          {showPassword ? '👁️' : '👁️‍🗨️'}
        </button>
      </div>
    </div>
  );
}